/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export type ApiServiceManagerNotesElData = ApiResponse & {
  /** 메모 생성 성공 여부 */
  data: boolean;
};

export interface ApiServiceManagerNotesEl2Params {
  /** 환자 아이디 */
  patientId: string;
  /** 커서 (serviceManagerNoteId). 최초 호출 이후 응답 값에 nextCursor 값이 주어집니다. */
  cursor?: string;
  /** 목록 조회 개수 제한 */
  limit?: number;
  /**
   * 정렬 방식 (1=오름차순, -1=내림차순)
   * @default 1
   */
  way?: 1 | -1;
}

export type ApiServiceManagerNotesEl2Data = ApiResponse & {
  data: {
    /** 전체 메모 수 */
    totalCount?: number;
    /** 현재 페이지 번호 */
    page?: number;
    /** 페이지당 메모 수 */
    limit?: number;
    /** 다음 페이지 존재 여부 */
    hasNextPage?: boolean;
    /** 다음 페이지 조회를 위한 커서 */
    nextCursor?: string;
    managerNotes?: {
      /** 서비스 매니저 메모 ID */
      managerNoteId?: string;
      /** 메모 내용 */
      content?: string;
      /**
       * 최종 수정 시간
       * @format date-time
       */
      finalEditedAt?: string;
      /** 최종 수정자 이름 */
      finalEditorName?: string;
      /** 고정 여부 */
      isPinned?: boolean;
      /**
       * 고정된 시간
       * @format date-time
       */
      pinnedAt?: string;
      /** 이미지 URL 목록 */
      images?: string[];
    }[];
  };
};

export type ApiServiceManagerNotesElUpdateData = ApiResponse & {
  /** 메모 수정 성공 여부 */
  data: boolean;
};

export type ApiServiceManagerNotesElRemoveData = ApiResponse & {
  /** 메모 삭제 성공 여부 */
  data: boolean;
};

export interface ApiServiceManagerNotesElDetailParams {
  /** 환자 아이디 */
  patientId: string;
}

export type ApiServiceManagerNotesElDetailData = ApiResponse & {
  data: {
    /** 서비스 매니저 메모 ID */
    managerNoteId?: string;
    /** 메모 내용 */
    content?: string;
    /**
     * 최종 수정 시간
     * @format date-time
     */
    finalEditedAt?: string;
    /** 최종 수정자 이름 */
    finalEditorName?: string;
    /** 고정 여부 */
    isPinned?: boolean;
    /**
     * 고정된 시간
     * @format date-time
     */
    pinnedAt?: string;
    /** 이미지 URL 목록 */
    images?: string[];
  };
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 특정 환자에 대한 서비스 매니저 메모를 생성합니다.
     *
     * @tags V3-ServiceManagerNote
     * @name ApiServiceManagerNotesEl
     * @summary 서비스 매니저 메모 생성
     * @request POST:/v3/api/service-manager-notes/el
     * @secure
     * @response `200` `ApiServiceManagerNotesElData` 서비스 매니저 메모 생성 성공
     */
    apiServiceManagerNotesEl: (
      data: {
        /** 환자 ID */
        patientId: string;
        /** 메모 내용 */
        content: string;
        /** 고정 여부 */
        isPinned: boolean;
        /** 이미지 URL 목록 */
        images?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiServiceManagerNotesElData, any>({
        path: `/v3/api/service-manager-notes/el`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 환자의 서비스 매니저 메모 목록을 조회합니다.
     *
     * @tags V3-ServiceManagerNote
     * @name ApiServiceManagerNotesEl2
     * @summary 서비스 매니저 메모 목록 조회 API
     * @request GET:/v3/api/service-manager-notes/el
     * @originalName apiServiceManagerNotesEl
     * @duplicate
     * @secure
     * @response `200` `ApiServiceManagerNotesEl2Data` 서비스 매니저 메모 목록 조회 성공
     */
    apiServiceManagerNotesEl2: (query: ApiServiceManagerNotesEl2Params, params: RequestParams = {}) =>
      this.request<ApiServiceManagerNotesEl2Data, any>({
        path: `/v3/api/service-manager-notes/el`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 서비스 매니저 메모를 수정합니다.
     *
     * @tags V3-ServiceManagerNote
     * @name ApiServiceManagerNotesElUpdate
     * @summary 서비스 매니저 메모 수정
     * @request POST:/v3/api/service-manager-notes/el/update
     * @secure
     * @response `200` `ApiServiceManagerNotesElUpdateData` 서비스 매니저 메모 수정 성공
     */
    apiServiceManagerNotesElUpdate: (
      data: {
        /** 서비스 매니저 메모 ID */
        managerNoteId: string;
        /** 수정할 메모 내용 */
        content?: string;
        /** 고정 여부 */
        isPinned?: boolean;
        /** 수정할 이미지 URL 목록 */
        images?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiServiceManagerNotesElUpdateData, any>({
        path: `/v3/api/service-manager-notes/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 서비스 매니저 메모를 삭제합니다.
     *
     * @tags V3-ServiceManagerNote
     * @name ApiServiceManagerNotesElRemove
     * @summary 서비스 매니저 메모 삭제
     * @request POST:/v3/api/service-manager-notes/el/remove
     * @secure
     * @response `200` `ApiServiceManagerNotesElRemoveData` 서비스 매니저 메모 삭제 성공
     */
    apiServiceManagerNotesElRemove: (
      data: {
        /** 삭제할 서비스 매니저 메모 ID */
        managerNoteId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiServiceManagerNotesElRemoveData, any>({
        path: `/v3/api/service-manager-notes/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 환자의 서비스 매니저 메모 상세 정보를 조회합니다.
     *
     * @tags V3-ServiceManagerNote
     * @name ApiServiceManagerNotesElDetail
     * @summary 서비스 매니저 메모 상세 조회 API
     * @request GET:/v3/api/service-manager-notes/el/detail
     * @secure
     * @response `200` `ApiServiceManagerNotesElDetailData` 서비스 매니저 메모 상세 조회 성공
     */
    apiServiceManagerNotesElDetail: (query: ApiServiceManagerNotesElDetailParams, params: RequestParams = {}) =>
      this.request<ApiServiceManagerNotesElDetailData, any>({
        path: `/v3/api/service-manager-notes/el/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
